import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Form, Formik } from "formik";
import { useState } from "react";
//@ts-ignore
import MUIEditor, { MUIEditorState } from "react-mui-draft-wysiwyg";
import * as yup from "yup";
import LabelsContext from "../../../../lang/LabelsContext";
import { muiControls, richTextStateToHtml } from "../../../../utils/Utils";

export default function TicketDialog(props: any) {
  const { open, setOpen, ticketSave, enumTicketTypeList } = props;
  const [editorState, setEditorState] = useState(MUIEditorState.createEmpty());
  const { Labels } = LabelsContext();

  const validationSchema = yup.object().shape({
    name: yup.string().required(Labels.NAME_REQUIRED),
    content: yup.string().required(Labels.CONTENT_REQUIRED),
    type: yup.string().required(Labels.TYPE_REQUIRED),
  });
  return (
    <div>
      <Divider />
      <Dialog open={open} aria-labelledby="form-dialog-title" maxWidth={"lg"}>
        <DialogTitle id="form-dialog-title">{Labels.NEW_TICKET}</DialogTitle>
        <Formik
          validationSchema={validationSchema}
          onSubmit={(values) => {
            ticketSave(values);
          }}
          initialValues={{
            name: "",
            content: "",
            type: "",
          }}
        >
          {({ handleBlur, values, touched, errors, handleChange, setFieldValue }) => (
            <Form>
              <DialogContent>
                <Typography>{Labels.NEW_TICKET_HELP}</Typography>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      id="name"
                      name="name"
                      label={Labels.SUBJECT}
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name && errors.name}
                      required
                      placeholder={Labels.SUBJECT_PLACEHOLDER}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Autocomplete
                      options={enumTicketTypeList}
                      onChange={(event, newValue) => {
                        setFieldValue("type", newValue.typeCode);
                      }}
                      getOptionLabel={(option: any) => option.typeName}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          margin="normal"
                          id="type"
                          name="type"
                          value={values.type}
                          onBlur={handleBlur}
                          label={"Ticket type"}
                          error={touched.type && Boolean(errors.type)}
                          helperText={touched.type && errors.type}
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <MUIEditor
                      defaultValue={values.content}
                      editorState={editorState}
                      onChange={(state: any) => {
                        setEditorState(state);
                        setFieldValue("content", richTextStateToHtml(state));
                      }}
                      config={{
                        toolbar: {
                          controls: muiControls,
                        },
                        draftEditor: {
                          stripPastedStyles: true,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    setOpen(false);
                  }}
                  color="primary"
                >
                  {Labels.CANCEL}
                </Button>
                <Button variant="contained" color="primary" type="submit">
                  {Labels.SEND}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div>
  );
}
